import gql from 'graphql-tag';
import {
	CommentFragment,
	PageInfoFragment,
} from '@app/pages/cmms/graphql/cmms-fragments';
import { SimpleLabelFragment } from '@app/pages/settings/graphql/labels.queries';

export const RequestsFragment = gql`
	fragment RequestsFragment on RequestType {
		approver {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
		}
		approverType
		assigneeType
		assignee {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
		}
		locations {
			id
			locationId
			locationType
			name
			pk
		}
		files {
			pk
			file {
				contentType
				name
				url
			}
			classificationsV2 {
				name
				type
				pk
			}
			createdBy {
				name
				lastName
				smallAvatarUrl
			}
			created
			type
			name
			importConfirmed
			importId
		}
		assets {
			id
			name
			pk
			location {
				name
				type
			}
		}
		categories {
			name
		}
		category
		createdBy {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
		}
		created
		description
		events {
			created
			event
		}
		id
		name
		pk
		priority
		status
		requestId
		updated
		workOrders {
			priority
			id
			pk
			name
			status
			workOrderId
		}
		incidents {
			priority
			id
			pk
			name
			status
			incidentId
		}
		comments {
			...CommentFragment
		}
		labels {
			...SimpleLabelFragment
		}
		requestees {
			name
			email
		}
	}
	${CommentFragment}
	${SimpleLabelFragment}
`;

export const RequestExportFragment = gql`
	fragment RequestExportFragment on RequestTypeConnection {
		exportUrl
	}
`;

export const RequestsQuery = gql`
	query RequestsQuery(
		$first: Int
		$last: Int
		$after: String
		$before: String
		$assignee: [String]
		$name: String
		$description: String
		$requestId: [BigInt]
		$status: [String]
		$priority: [Int]
		$sortBy: String
		$search: String
		$category: [String]
		$locations: [UUID]
		$exportColumns: [String]
		$isExportQuery: Boolean = false
		$labels: [ID]
	) {
		requests(
			first: $first
			after: $after
			before: $before
			last: $last
			assignee: $assignee
			name: $name
			description: $description
			requestId_In: $requestId
			status: $status
			priority_In: $priority
			sortBy: $sortBy
			search: $search
			category: $category
			locations: $locations
			exportColumns: $exportColumns
			labels_Id_In: $labels
		) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...RequestsFragment
				}
			}
			totalCount

			...RequestExportFragment @include(if: $isExportQuery)
		}
	}
	${RequestsFragment}
	${PageInfoFragment}
	${RequestExportFragment}
`;

export const GetRequestQuery = gql`
	query GetRequestQuery($id: UUID) {
		request(id: $id) {
			...RequestsFragment
		}
	}
	${RequestsFragment}
`;

export const RequestsSearchQuery = gql`
	query RequestsQuery(
		$search: String
		$first: Int
		$last: Int
		$after: String
		$before: String
	) {
		requests(
			search: $search
			first: $first
			last: $last
			after: $after
			before: $before
		) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...RequestsFragment
				}
			}
			totalCount
		}
	}
	${RequestsFragment}
	${PageInfoFragment}
`;

export const SummarizeRequestsQuery = gql`
	query SummarizeRequestsQuery($objectId: String!) {
		summarizeRequest(objectId: $objectId) {
			description
			subject
		}
	}
`;
